import app from 'vue'
import router from '@/router'

const handleRoute = (binding) => (event) => {
  if (event instanceof MouseEvent || event instanceof KeyboardEvent && event.key === 'Enter') {
    let { arg: name, value: options, modifiers } = binding

    if (options && options.unless) {
      return
    }

    if (options && !options.params && !options.query) {
      options = { params: options }
    }

    if (Object.keys(modifiers).length) {
      name += '.' + Object.keys(modifiers).join('.')
    }

    router.push({ name, ...options || {} }).catch(error => {
      if (error) {
        console.error(error)
      } else {
        console.warn('Unable to route, but did not receive an error.')
      }
    })
  }
}

app.directive('route', {
  inserted: (element, binding) => {
    element.addEventListener('click', handleRoute(binding))
    element.addEventListener('keyup', handleRoute(binding))
  },

  unbind: (element, binding) => {
    element.removeEventListener('click', handleRoute(binding))
    element.removeEventListener('keyup', handleRoute(binding))
  }
})
